export default __webpack_public_path__ + "static/media/evidence-map-bg.d53c6ba1.jpg";